import { AGSubject } from '@gpa-scales/shared-types';

export const AG_SUBJECT_LABELS: Record<AGSubject, string> = {
  [AGSubject.A]: 'History/Social Science',
  [AGSubject.B]: 'English',
  [AGSubject.C]: 'Mathematics',
  [AGSubject.D]: 'Laboratory Science',
  [AGSubject.E]: 'Language Other Than English',
  [AGSubject.F]: 'Visual & Performing Arts',
  [AGSubject.G]: 'College-Preparatory Elective',
  [AGSubject.None]: 'Not A-G',
};

export const AG_SUBJECT_DESCRIPTIONS: Record<AGSubject, string> = {
  [AGSubject.A]: 'History, government, economics, geography, world history',
  [AGSubject.B]: 'English literature, composition, language arts',
  [AGSubject.C]: 'Algebra, geometry, calculus, statistics',
  [AGSubject.D]: 'Biology, chemistry, physics, earth science',
  [AGSubject.E]: 'Spanish, French, Mandarin, ASL, etc.',
  [AGSubject.F]: 'Visual art, music, theater, dance',
  [AGSubject.G]: 'Elective courses approved as college-preparatory',
  [AGSubject.None]: 'Course does not fall into an A-G category',
};

export const AG_SUBJECT_CATEGORIES: AGSubject[] = [
  AGSubject.A,
  AGSubject.B,
  AGSubject.C,
  AGSubject.D,
  AGSubject.E,
  AGSubject.F,
  AGSubject.G,
];
